/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molarity calculator: find mass, molarity, volume or molecular weight from mass = molarity × volume × molecular weight.`)
};

const es_massmol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de molaridad: calcula masa, molaridad, volumen o peso molecular a partir de masa = molaridad × volumen × peso molecular.`)
};

const de_massmol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molaritätsrechner: Finden Sie Masse, Molarität, Volumen oder Molekulargewicht aus Masse = Molarität × Volumen × Molekulargewicht.`)
};

const nl_massmol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molariteitscalculator: bereken massa, molariteit, volume of molecuulgewicht uit massa = molariteit × volume × molecuulgewicht.`)
};

const fr_massmol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de molarité : trouvez la masse, la molarité, le volume ou la masse moléculaire à partir de masse = molarité × volume × masse moléculaire.`)
};

const it_massmol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di molarità: trova massa, molarità, volume o peso molecolare da massa = molarità × volume × peso molecolare.`)
};

const pt_br2_massmol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de molaridade: encontre massa, molaridade, volume ou peso molecular a partir de massa = molaridade × volume × peso molecular.`)
};

const pt_massmol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de molaridade: calcule a massa, a molaridade, o volume ou a massa molecular a partir de massa = molaridade × volume × massa molecular.`)
};

const ja_massmol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モル濃度計算ツール: 質量 = モル濃度 × 体積 × 分子量から、質量・モル濃度・体積・分子量を求めます。`)
};

const zh_massmol_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摩尔浓度计算器：根据质量 = 摩尔浓度 × 体积 × 分子量求解质量、摩尔浓度、体积或分子量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_tool_description", locale)
	if (locale === "en") return en_massmol_tool_description(inputs)
	if (locale === "es") return es_massmol_tool_description(inputs)
	if (locale === "de") return de_massmol_tool_description(inputs)
	if (locale === "nl") return nl_massmol_tool_description(inputs)
	if (locale === "fr") return fr_massmol_tool_description(inputs)
	if (locale === "it") return it_massmol_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_tool_description(inputs)
	if (locale === "pt") return pt_massmol_tool_description(inputs)
	if (locale === "ja") return ja_massmol_tool_description(inputs)
	return zh_massmol_tool_description(inputs)
};